import { render, staticRenderFns } from "./ShippingCostPerCountry.vue?vue&type=template&id=51cf8dcf&"
import script from "./ShippingCostPerCountry.vue?vue&type=script&lang=js&"
export * from "./ShippingCostPerCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports